import React from 'react';
import {Helmet} from 'react-helmet';
import {useQuery} from 'react-apollo-hooks';
import gql from 'graphql-tag';

import {Card, Loading} from 'ui-kit';
import {SettingsSection} from '../SettingsSection';

import {BillingInfo, PayoutDestination, PayoutsList} from './components';

export function Billing() {
  const {data, loading, error, refetch} = useQuery(
    gql`
      query BillingSettingsQuery {
        me {
          ... on StaffMember {
            id
            practice {
              id
              payoutAccount {
                id
                accountHolderName
                bankName
                last4
                routingNumber
              }
              payouts(first: 5) {
                edges {
                  node {
                    id
                    amount
                    status
                    arrivalDate
                  }
                }
              }
              billingSource {
                id
                last4
              }
            }
          }
        }
      }
    `,
    {
      options: {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'network-only',
      },
    },
  );

  if (loading) {
    return <Loading />;
  }

  function handlePayoutDestinationSuccess() {
    refetch();
  }

  function handleBillingSourceSuccess() {
    refetch();
  }

  return (
    <div>
      <Helmet title="Billing and payment settings" />

      <SettingsSection
        title="Payouts"
        description="You will receive payouts when members or their membership renews."
      >
        {error == null ? (
          <>
            <PayoutDestination
              payoutAccount={data.me.practice.payoutAccount}
              onSuccess={handlePayoutDestinationSuccess}
            />

            <PayoutsList
              payouts={data.me.practice.payouts.edges.map(({node}) => node)}
            />
          </>
        ) : (
          <Card>
            <p>
              An unexpected error occurred. You can refresh this page or try
              again later.
            </p>
          </Card>
        )}
      </SettingsSection>

      <SettingsSection
        title="Billing source"
        description="This is the card to which your monthly Plum subscription will be charged."
      >
        {error == null ? (
          <BillingInfo
            billingSource={data.me.practice.billingSource}
            onSuccess={handleBillingSourceSuccess}
          />
        ) : (
          <Card>
            <p>
              An unexpected error occurred. You can refresh this page or try
              again later.
            </p>
          </Card>
        )}
      </SettingsSection>
    </div>
  );
}
